/* eslint-disable */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';
import {
  makeStyles,
  Card,
  Grid,
  Typography,
  CardContent,
} from '@rentacenter/racstrap';
import Calender from './DapCalendar/Calender';
import { customerStyles } from './DapCalendar/customerStyles';
import { DapCalendarStyles } from './DapCalendar/DapCalendarStyles';
import Tab from './DapCalendar/Tab';
import Task from './DapCalendar/Task';
import { fetchOrganizationDetails, getSalesPersonOptions1 } from '../../api/user';
import { FeatureFlagContext } from '../../context/featureFlagContext';
import { ContainerContext } from '../../app/App';
import { useTranslation } from 'react-i18next';
//UI
const useClasses = makeStyles((theme: any) => ({
  w100: {
    width: '100%',
  },
  mb2: {
    marginBottom: theme.typography.pxToRem(8),
  },
  title: {
    color: '#212529',
    fontFamily: 'OpenSans-bold!important',
    fontSize: '16px!important',
    marginBottom: '10px!important',
  },
  titleColor: {
    color: '#60647F',
  },
  infoTextStyle: {
    color: '#A5A6A6',
    fontSize: theme.typography.pxToRem(14),
    textAlign: 'center',
  },
  mb3: {
    marginBottom: theme.typography.pxToRem(16),
  },
  mb4: {
    marginBottom: theme.typography.pxToRem(24),
  },

  mb5: {
    marginBottom: theme.typography.pxToRem(48),
  },
  my4: {
    marginTop: theme.typography.pxToRem(24),
    marginBottom: theme.typography.pxToRem(24),
  },
  card: {
    borderRadius: '16px!important',
    boxShadow: '0 1px 4px 0 rgba(0,0,0,.074)!important',
    width: '100%',
  },
  px2: {
    paddingRight: theme.typography.pxToRem(8),
    paddingLeft: theme.typography.pxToRem(8),
  },

  mt2: {
    marginTop: theme.typography.pxToRem(8),
  },
  mt3: {
    marginTop: theme.typography.pxToRem(16),
  },
  pt3: {
    paddingTop: theme.typography.pxToRem(16),
  },
  pt2: {
    paddingTop: theme.typography.pxToRem(8),
  },
  pt1: {
    paddingTop: theme.typography.pxToRem(4),
  },
}));
export default function Upcoming(props?: any) {
  const {t}= useTranslation('task');
  const {  MXStoreIdentifier } = useContext(FeatureFlagContext);
  const classes = useClasses();
  const [tab, setTab] = useState('calender')
  const classes1 = DapCalendarStyles();
  const customerStyleClasses = customerStyles();
    const containerData = useContext(ContainerContext);
  const [storeEventDD, setStoreEventDD] = useState<any>([{ label: t('ALL'), value: '' }]);
  const [assigneeEventDD, setAssigneeEventDD] = useState<any>([{ label: t('ALL'), value: '' }]);
  const [assignee, setassignee] = useState<string | string[]>(containerData?.GetEmployeeId() ? containerData?.GetEmployeeId() : '');
  const [isLoading, setIsLoading] =  useState(false);


  const [store, setStore] = useState('');
    interface SalesPerson {
    value: string;
    label: string ;
  }
  useEffect(() => {
    if(Number(MXStoreIdentifier) == 1){
    referenceData();
  }
  }, [MXStoreIdentifier])

 


  const referenceData = async () => {
    const storeNumber = window.sessionStorage.getItem('storeNumber');
    const dapStoreDetails: any = { type: "STORE", filterType: "STORE-CENTRALIZED", filterValue: [storeNumber] };
     setIsLoading(true)
    const dapStoreDetailsResponse: any = await fetchOrganizationDetails(dapStoreDetails);
    console.log("dapStoreDetailsResponse", dapStoreDetailsResponse)
    if (dapStoreDetailsResponse?.status === 200) {
      let storeList: any = [];
           if (dapStoreDetailsResponse?.data == "") {
          const storenumber = window.sessionStorage.getItem("storeNumber");
          storeList = [storenumber];
          const result = [
            { label: t("ALL"), value: "" },
            { label: storenumber, value: storenumber },
          ];
          setStoreEventDD(result);
        }else{
           const result = dapStoreDetailsResponse?.data?.result?.map((item: any) => {
           storeList.push(String(item.referenceName));
           return { label: item.referenceName, value: item.referenceName }
          })
          result.unshift({ label: t('ALL'), value: '' });
          setStoreEventDD(result);

        }
    
        const getSalesPerson: any = await getSalesPersonOptions1({ storeNumbers: storeList, callSalesPersonApi: true , storeNumber:window.sessionStorage.getItem("storeNumber") });
        if (getSalesPerson.status == 200) {
          const uniqueSalesPersons: SalesPerson[] = []; // Specify the type here

          const uniqueIds: { [key: string]: boolean } = {}; // Type for uniqueIds
          if (Array.isArray(getSalesPerson.data?.salespersonsData)) {
            getSalesPerson.data?.salespersonsData.forEach(item => {
              const uniqueId = item.appUserName + item.employee_id;
              if (!uniqueIds[uniqueId]) {
                uniqueIds[uniqueId] = true; // Mark this ID as seen
                uniqueSalesPersons.push({
                   label: item.appUserName,
                   value: item.employee_id
                });
                  
              }
            });
          } else {
            console.log(
              "getSalesPerson.data is not an array:",
              getSalesPerson.data
            );
          } 
          uniqueSalesPersons.unshift({ label: t('ALL'), value: ""});// Convert array to string 
          setAssigneeEventDD(uniqueSalesPersons);
          console.log(uniqueSalesPersons,"salesperson values");
          
          console.log(assignee,"assignee value")
          if(assignee){
           let truckDriverLogin =  uniqueSalesPersons.find(element => String(element.value) === String(assignee));
           console.log(truckDriverLogin,"truckdriver");
           
           if(truckDriverLogin){
            setStore("")
           }else{
            let storeNumber =  window.sessionStorage.getItem('storeNumber') ;
            
            if (storeNumber !== null) {
               setStore(storeNumber);
               setassignee("")
              }             
           }
          
          }
          
        }
        

    }
    setIsLoading(false)
  }
  


  return (
    <>
      {/* <Grid  container > */}
      <Grid item className={`${classes.px2} ${classes.w100}`}>
        {/* <Card className={`${classes.w100} ${classes.card}`}> */}
        <Card
          className={`${classes1.cardForDashboard} ${customerStyleClasses.w100}`}
          style={{ borderRadius: '1rem' }}
        >
          <CardContent
            className={`${classes1.headerTab} ${customerStyleClasses.floatLeft} ${customerStyleClasses.w100} ${classes1.py0}`} style={{ padding: '0px' }}
          >
            {/* <CardContent>
            <Typography
              variant="h6"
              className={`${classes.title} ${classes.titleColor}`}
            >
              {props.name}
            </Typography>

            <Grid className={`${classes.infoTextStyle} ${classes.my4}`}>
              <Typography>Coming Soon!</Typography>
            </Grid>
            <Grid className={`${classes.infoTextStyle} ${classes.mb5}`}>
              <Typography>
                We are currently working on this feature and will launch soon!
              </Typography>
            </Grid>
          </CardContent> */}
            <Tab setTab={setTab}
              storeEventDD={storeEventDD} assigneeEventDD={assigneeEventDD}
              assignee={assignee} setassignee={setassignee}
              store={store} setStore={setStore} />
            {tab == 'calender' ? <Calender assignee={assignee} store={store} storeEventDD={storeEventDD} assigneeEventDD={assigneeEventDD} isLoading={isLoading}
              setassignee={setassignee}
              setStore={setStore} /> : <Task />}
            {/* <Calender /> */}
          </CardContent>
        </Card>
      </Grid>
      {/* </Grid> */}
    </>
  );
}
